/* eslint-disable @typescript-eslint/no-non-null-assertion */
import ordinal from 'ordinal';
import { IErrorDetail, ShowWhere } from '../../interfaces/validation.interface';
import { PatternsConstraintsGroup } from './PatternsConstraintsGroup';
import { PatternsConstraints } from './PatternsConstraints';
import { tagToReadable } from '../../../../utils/tagToReadable';
import { IBlockConfig } from './interfaces/patternsConfig.interface';
import { PatternsReader } from './PatternsReader';
import { lengthToReadable } from '../../../../utils/lengthToReadable';
import { IParsedHtml } from './interfaces/parsedHtml';
import capitalize from '../../../../utils/capitalize';

export class PatternsErrorFactory {
  constructor(
    private group: PatternsConstraintsGroup,
    private constraints: PatternsConstraints,
  ) {}

  createNotExists(): IErrorDetail {
    return {
      message: `In <em>${this.hasSeparator() ? `${ordinal(this.constraints.currentChunkIndex + 1)} ` : ''}${capitalize(this.constraints.currentGroup!.name!)}</em>, a <b>${tagToReadable((this.group.currentBlockConfig as IBlockConfig).tag)}</b> is required after <b>${tagToReadable((this.group.previousBlockConfig as IBlockConfig).tag)}</b>, but it doesn't exists`,
      category: this.constraints.currentPattern!.name,
      meta: {
        validator: 'patterns',
        type: 'missing-tag',
        line: PatternsReader.getFinalGlobalIndex(this.group.nodes, this.group.currentNodeIndex - 1) + 1,
        showWhere: 'after',
        resumed: `The ${tagToReadable((this.group.currentBlockConfig as IBlockConfig).tag)} is required after ${tagToReadable((this.group.previousBlockConfig as IBlockConfig).tag)}, but it doesn't exists`,
      },
    };
  }

  createNotExistsStart(): IErrorDetail {
    let line = -1;
    let showWhere: ShowWhere = 'after';

    if (this.hasSeparator()) {
      if (this.constraints.currentChunkIndex === 0) {
        line = this.constraints.startDelimiter ? this.constraints.startDelimiter.line[0] + 1 : 1;
      } else {
        line = this.constraints.separators[this.constraints.currentChunkIndex - 1].line[0] + 1;
      }
    } else if (this.constraints.startDelimiter) {
      line = this.constraints.startDelimiter.line[0] + 1;
    } else {
      line = 1;
      showWhere = 'before';
    }

    return {
      message: `On start of <em>${this.hasSeparator() ? `${ordinal(this.constraints.currentChunkIndex + 1)} ` : ''}${capitalize(this.constraints.currentGroup!.name!)}</em>, a <b>${tagToReadable((this.group.currentBlockConfig as IBlockConfig).tag)}</b> is required, but it doesn't exists`,
      category: this.constraints.currentPattern!.name,
      meta: {
        validator: 'patterns',
        type: 'missing-tag-start',
        line,
        showWhere,
        resumed: `The ${tagToReadable((this.group.currentBlockConfig as IBlockConfig).tag)} is required on start of ${capitalize(this.constraints.currentGroup!.name!)}, but it doesn't exists`,
      },
    };
  }

  createLengthIsIncorrect(): IErrorDetail {
    return {
      message: `In <em>${this.hasSeparator() ? `${ordinal(this.constraints.currentChunkIndex + 1)} ` : ''}${capitalize(this.constraints.currentGroup!.name!)}</em>, the <b>${tagToReadable((this.group.currentBlockConfig as IBlockConfig).tag)}</b> amount is incorrect (should be ${lengthToReadable((this.group.currentBlockConfig as IBlockConfig).amount)}, now is ${this.group.currentNode!.amount})`,
      category: this.constraints.currentPattern!.name,
      meta: {
        validator: 'patterns',
        type: 'incorrect-amount',
        line: (this.group.currentNode as IParsedHtml).line[0] + 1,
        lineRange: [(this.group.currentNode as IParsedHtml).line[0] + 1, (this.group.currentNode as IParsedHtml).line[1] + 1],
        resumed: `The ${tagToReadable((this.group.currentBlockConfig as IBlockConfig).tag)} amount is incorrect (should be ${lengthToReadable((this.group.currentBlockConfig as IBlockConfig).amount)}, now is ${this.group.currentNode!.amount})`,
      },
    };
  }

  private hasSeparator() {
    return !!this.constraints.currentGroup?.separator;
  }
}
